import { IContainer } from '../../interface/container';
import { bindStoresRenderer, injectStoresData } from '../interface';
import renderer from './StoreRender';

function binder(container: IContainer) {
    const stores = injectStoresData(container);

    const result = renderer(stores);

    bindStoresRenderer(result, container);
}

export default binder;
